var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "31px",
    viewBox: "0 0 40 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1906473C-81BE-4962-9802-0136247477FA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BOOKING-4",
    transform: "translate(-833.000000, -1284.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(10.000000, 832.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy",
    transform: "translate(0.000000, 376.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "view-details-group-copy",
    transform: "translate(802.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-light",
    transform: "translate(21.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.13644649,7.19642857 C11.1292423,4.42857143 15.1080635,2.21428571 19.9965281,2.21428571 C24.8849926,2.21428571 28.8638139,4.42857143 31.8566097,7.19642857 C34.8494054,9.96428571 36.8492318,13.2857143 37.7727628,15.5 C36.8492318,17.7142857 34.8494054,21.0357143 31.8566097,23.8035714 C28.8638139,26.5714286 24.8849926,28.7857143 19.9965281,28.7857143 C15.1080635,28.7857143 11.1292423,26.5714286 8.13644649,23.8035714 C5.14365072,21.0357143 3.14382432,17.7142857 2.22029338,15.5 C3.14382432,13.2857143 5.14365072,9.96428571 8.13644649,7.19642857 Z M19.9965281,0 C14.385904,0 9.89323843,2.54642857 6.622689,5.57723214 C3.3729711,8.58035714 1.19954865,12.1785714 0.171860082,14.6488839 C-0.0572866939,15.1955357 -0.0572866939,15.8044643 0.171860082,16.3511161 C1.19954865,18.8214286 3.3729711,22.4196429 6.622689,25.4227679 C9.89323843,28.4535714 14.385904,31 19.9965281,31 C25.6071522,31 30.0998177,28.4535714 33.3703672,25.4227679 C36.6200851,22.4127232 38.7935075,18.8214286 39.8281399,16.3511161 C40.0572867,15.8044643 40.0572867,15.1955357 39.8281399,14.6488839 C38.7935075,12.1785714 36.6200851,8.58035714 33.3703672,5.57723214 C30.0998177,2.54642857 25.6071522,0 19.9965281,0 Z M13.3304401,15.5 C13.3304401,11.8312513 16.3149493,8.85714286 19.9965281,8.85714286 C23.6781068,8.85714286 26.6626161,11.8312513 26.6626161,15.5 C26.6626161,19.1687487 23.6781068,22.1428571 19.9965281,22.1428571 C16.3149493,22.1428571 13.3304401,19.1687487 13.3304401,15.5 L13.3304401,15.5 Z M28.8846454,15.5 C28.8846454,10.6083351 24.9052997,6.64285714 19.9965281,6.64285714 C15.0877564,6.64285714 11.1084107,10.6083351 11.1084107,15.5 C11.1084107,20.3916649 15.0877564,24.3571429 19.9965281,24.3571429 C24.9052997,24.3571429 28.8846454,20.3916649 28.8846454,15.5 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLight);
export default __webpack_public_path__ + "static/media/eye-light.566e554c58096923bd6357ac446dd4ca.svg";
export { ForwardRef as ReactComponent };